// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --configuration production` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  serviceWorker: true,
    firebase: {
      apiKey: 'AIzaSyCTmZ8Si2elE55w4JmpW5aoJx2Perx8mys',
      authDomain: 'pwa-angular-46be8.firebaseapp.com',
      databaseURL: 'https://pwa-angular-46be8.firebaseio.com',
      projectId: 'pwa-angular-46be8',
      storageBucket: 'pwa-angular-46be8.appspot.com',
      messagingSenderId: '389740270924',
      appId: '1:389740270924:web:7f32217714c1ba7343abe9'
    }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
